import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { DocumentAssetTypeEnum } from './DocumentAssetTypeEnum'

@ObjectType()
@InputType('MatchedDocumentInput')
export class MatchedDocument {
  @Field(() => String)
  documentCode: string

  @Field(() => DocumentAssetTypeEnum, { nullable: true })
  documentType: DocumentAssetTypeEnum | null

  @Field(() => Boolean)
  exists: boolean

  @Field(() => ID, { nullable: true })
  documentId?: string
}
